import React from "react";
import { createRoot } from 'react-dom/client';
import "./index.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import App from "./App";

const container = document.getElementById('root');
const root = createRoot(container); // create a root
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
